import { useAuthCtx } from '@/app/context/auth/authContextController/AuthContextController';
import { useDynamicLocale } from '@/hoslog-intl';
import { LogoutCircle } from '@/icons';
import { Avatar, AvatarFallback, AvatarImage } from 'ui/avatar';
import { useConfirmationStore } from '../dialog/confirmation.store';
import { getInitials } from './helpers';
import { TruncatedTooltipValue } from '../layout/TruncatedTooltipValue';

interface User {
  user: {
    fullName: string;
    email?: string;
    profileImage?: string;
  };
}

export function NavUser({ user }: User) {
  const { fullName, email, profileImage } = user;
  const initial = getInitials(fullName);
  const { logout } = useAuthCtx();

  const { t } = useDynamicLocale();

  const { openConfirmation } = useConfirmationStore();
  return (
    <div className="flex py-2 gap-2 text-secondary items-center">
      <Avatar className="size-7 aspect-square rounded-full">
        <AvatarImage src={profileImage} alt={fullName} />
        <AvatarFallback className="rounded-full text-sidebar-content">{initial}</AvatarFallback>
      </Avatar>
      <div className="max-w-28">
        <TruncatedTooltipValue
          content={fullName ?? ''}
          className="text-sm font-bold text-sidebar-content leading-4 max-w-28"
        />
        <TruncatedTooltipValue content={email ?? ''} className="text-[8px] max-w-28" />
      </div>
      <LogoutCircle
        className="size-5 aspect-square ml-auto hover:cursor-pointer"
        onClick={() => {
          openConfirmation({
            title: t('common.page.modal.confirmation.title'),
            description: t('common.page.modal.logoutMessage'),
            cancelLabel: t('common.page.modal.no'),
            actionLabel: t('common.page.modal.confirm'),
            onAction: async () => {
              await logout({});
            },
            onCancel: () => {},
            size: 'lg',
            variant: 'destructive',
          });
        }}
      />
    </div>
  );
}
